import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, MenuIcon, SaveIcon, SendIcon, SendTicketIcon, TicketBackIcon, TicketStatusIcon, TicketStatusSaveIcon } from '../Icons/icons.component';
import { useSelector } from 'react-redux';
import { COOKIE } from '../../constants/app-constant';
import { getCookie } from '../../utility/cookieProvider';
import Loader from './Loader';
import { sendTicketReply, sendTicketStatusUpdate } from '../../actions/tickets-action';
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";

const Ticket = ({ setShowList, ticketData, messageData = [], msgUserList = [], isMsgLoading }) => {
  const masterUser = useSelector((state) => state.clientReducer && state.clientReducer.masterUser) || {};
  const [selectedFile, setSelectedFile] = useState(null);
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState(0);
  const [notifyMaster, setNotifyMaster] = useState(1);

  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    const validFiles = [];
  
    for (let file of filesArray) {
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} size should not exceed 5MB.`);
        continue;
      }
      if (file.type !== "application/pdf" && !file.type.startsWith("image/")) {
        alert(`${file.name} is not a valid file type (only PDF and images allowed).`);
        continue;
      }
      validFiles.push(file);
    }
  
    if (validFiles.length > 0) {
      setSelectedFile(validFiles);
    }
  };
  
  useEffect(() => {
    setMessages(messageData);
  }, [messageData]);

  useEffect(() => {
    setStatus(ticketData.status ? ticketData.status : 0);
  }, [ticketData]);

  const sendMessage = async (text, files) => {
    if (!text.trim() && (!files || files.length === 0)) return;
  
    let tObj = new FormData();
    let tObj1;
  
    tObj.append("header_id", ticketData.header_id);
    tObj.append("user_id", ticketData.user_id);
    tObj.append("message", text || "");
    tObj.append("created_by", userId);
    tObj.append("notify_master", notifyMaster);
    tObj.append("master_id", ticketData.master_id);
    tObj.append("client_id", ticketData.client_id);
    
    if (files && files.length > 0) {
      for (let file of files) {
        tObj.append("files", file); // backend should support multiple files
      }
  
      const base64Files = await Promise.all(
        files.map((file) => toBase64(file))
      );
  
      tObj1 = {
        header_id: ticketData.header_id,
        user_id: ticketData.user_id,
        message: text,
        created_by: userId,
        notify_master: notifyMaster,
        master_id: ticketData.master_id,
        client_id: ticketData.client_id,
        file_name : base64Files,
        local : true
        // content: base64Files,
      };
    } else {
      tObj1 = {
        header_id: ticketData.header_id,
        user_id: ticketData.user_id,
        message: text,
        created_by: userId,
        notify_master: notifyMaster,
        master_id: ticketData.master_id,
        client_id: ticketData.client_id,
      };
    }
  
    const resData = await sendTicketReply(tObj, !!files);
    if (resData) {
      const newMessage = tObj1;
      setMessages((prevMessages) => [...prevMessages, newMessage]);
    }
  };
  

  function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }
  
  const handleSend = () => {
    sendMessage(input, selectedFile);
    setInput("");
    setSelectedFile([]);
  };
  

  const handleStatusUpdate = async () => {
    const tObj = {
      id: ticketData.header_id,
      status: status,
      client_id: ticketData.client_id,
    };
    const resStatus = await sendTicketStatusUpdate(tObj);
    if (resStatus) {
      console.log("Status updated successfully.");
    }
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <div style={{ height: '100vh' }}>
        <div className="article-header">
          <div className="d-flex customWrap">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Article Tracking</h1>
              </div>
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Article Tracking</h1>
            </div>
            <div className="titleRow d-blockd">
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  <button className="prev-button" onClick={() => { setShowList(true); }}>
                    <ArrowLeftIcon color={'#FFFFFF'} /> <label style={{ marginLeft: 5, marginBottom: 0 }}> Back </label>
                  </button>
                </div>
                <div className="filterWrap">
                  <a target="_blank" href={ticketData?.article_url}>
                    <button className="prev-button">
                      <TicketBackIcon /> View Article
                    </button>
                  </a>
                </div>
                <div className="filterWrap">
                  <label>Heading: {ticketData.heading}</label>
                </div>
              </div>
              <div className="rightBtnContainer">
                <ul className="dropDownContainer">
                  {Object.keys(masterUser).length ? (
                    <div role="group" className="rs-btn-group btn-group" style={{ alignItems: "center" }}>
                      <TicketStatusIcon />
                      <label style={{ marginLeft: 5, marginBottom: 0 }}>Status Update</label>
                      <ul name="status" className="MEDIA_TYPE Filter show">
                        <li className="filterOption">
                          <label className="inputWrap">In Progress
                            <input
                              onClick={(e) => { if (e.target.checked) setStatus(1); }}
                              type="radio"
                              checked={status === 1}
                              disabled={status === 1}
                              value={1}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </li>
                        <li className="filterOption">
                          <label className="inputWrap">Completed
                            <input
                              type="radio"
                              onClick={(e) => { if (e.target.checked) setStatus(2); }}
                              checked={status === 2}
                              disabled={status === 2}
                              value={2}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </li>
                      </ul>
                      <button onClick={handleStatusUpdate} className="prev-button">
                        <TicketStatusSaveIcon />
                      </button>
                    </div>
                  ) : ""}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: '90%', overflowY: 'auto',marginBottom:'18%' }}>
          {isMsgLoading ? (
            <Loader />
          ) : (
            messages.map((msg, index) => (
              <div
                key={index}
                className={`message-container ${Number(msg.created_by) === Number(userId) ? "user" : "bot"}`}
              >
                {/* Name Label */}
                {Number(msg.created_by) !== Number(userId)?
                  <div className="message-label hasTooltip">
                    {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name?.split(" ").map((splitData) => splitData.substr(0,1))}
                    <span className="tooltipWrap center">
                      {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name}
                    </span>
                  </div>
                :""}
                {Number(msg.created_by) === Number(userId)?
                  (msg.file_name && msg.file_name != ""?
                    msg.local?msg.file_name.map((file,index) => <div className='message-download'><a href={file} target='_blank' download={file}>
                    📄 File {index+1}
                    </a></div>):msg.file_name.split(",").map((file,index) => <div className='message-download'><a href={"https://social.conceptbiu.com/images/"+file} target='_blank' download={file}>
                    📄 File {index+1}
                    </a></div>)
                  :"")
                :""}
                {/* Message Content (text or files) */}
                <div className={`message`}>
                  {/* {msg.file_url ? (
                    msg.file_url.endsWith(".pdf") ? (
                      
                    ) : (
                      <img
                        src={msg.file_url}
                        alt="uploaded files"
                        style={{ maxWidth: "200px", borderRadius: "8px" }}
                      />
                    )
                  ) : ( */}
                    {msg.message}
                    
                  {/* )} */}
                </div>
                {Number(msg.created_by) !== Number(userId)?
                  (msg.file_name && msg.file_name != ""?
                    msg.local?msg.file_name.map((file,index) => <div className='message-download'><a href={file} target='_blank' download={file}>
                    📄 File {index+1}
                    </a></div>):msg.file_name.split(",").map((file,index) => <div className='message-download'><a href={"https://social.conceptbiu.com/images/"+file} target='_blank' download={file}>
                    📄 File {index+1}
                    </a></div>)
                  :"")
                  :""}
                {Number(msg.created_by) === Number(userId)?
                  <>
                    <div className="message-label hasTooltip">
                      {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name?.split(" ").map((splitData) => splitData.substr(0,1))}
                      <span className="tooltipWrap center">
                        {msgUserList.find((uData) => Number(uData.userId) == Number(msg.created_by))?.name}
                      </span>
                    </div>
                  </>
                :""}
                
              </div>
            ))
          )}
        </div>

        <div style={{ height: 'fit-content',marginTop:'-18%' }} className="chat-input">
          {status !== 2 ? (
            <>
              <ul className="dropDownContainer">
                <div role="group" className="rs-btn-group btn-group" style={{ alignItems: "center" }}>
                  <label style={{ marginLeft: 5, marginBottom: 0 }}>Notify Master</label>
                  <ul name="status" className="MEDIA_TYPE Filter show">
                    <li className="filterOption">
                      <input
                        type="checkbox"
                        checked={notifyMaster}
                        onClick={(e) => { setNotifyMaster(e.target.checked ? 1 : 0); }}
                      />
                      <span className="checkmark"></span>
                    </li>
                  </ul>
                </div>
              </ul>
              <input
                type="text"
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSend()}
              />
              &nbsp; &nbsp;
              <input
                type="file"
                id="fileInput"
                name="files"
                multiple
                className="custom-files"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
             <label htmlFor="fileInput" className="custom-label">
  <span className="label-text">Upload files</span>
  <span className="label-icon">
  📎 
  </span>


</label>

              {selectedFile && selectedFile.length > 0 && (
  <div
    title={selectedFile.map((f) => f.name).join(", ")} // tooltip
   className="selected-file-preview"
  >
    📎 {selectedFile.length} file{selectedFile.length > 1 ? "s" : ""} selected
  </div>
)}


              <div className="hasTooltip">
                <span className="tooltipWrap center">Send</span>
                <button onClick={handleSend} disabled={!input.trim() && !selectedFile}>
                  <SendTicketIcon fill={"#ffffff"} />
                </button>
              </div>
            </>
          ) : ""}
        </div>
      </div>
    </div>
  );
};

export default Ticket;
